import {
  FC, useCallback, useEffect, useState,
} from 'react';
import { FormalizedZipListItem } from 'entities/formalizedZip';
import { FormalizedZipRequestDto, FormalizedZipResponseDto } from 'shared/api';
import { EmptyState } from 'shared/ui';
import { useFormalizedZip } from '../hooks/useFormalizedZip';
import { FormalizedZipTable } from '../components/FormalizedZipTable/FormalizedZipTable';
import { FormalizedZipForm } from '../components/FormalizedZipForm/FormalizedZipForm';

export const FormalizedZipPage: FC = () => {
  const {
    formalizedZips,
    loadFormalizedZips,
    updateExisting,
    deleteById,
    loadDetail,
  } = useFormalizedZip();

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [editingItem, setEditingItem] = useState<FormalizedZipRequestDto | null>(null);
  const [editingId, setEditingId] = useState<number | null>(null);

  useEffect(() => {
    loadFormalizedZips();
  }, []);

  const mapDetailToForm = useCallback((detail?: FormalizedZipResponseDto | null): FormalizedZipRequestDto | null => {
    if (!detail) return null;
    return {
      engineId: detail.engineId || 0,
      zipOrderCode: detail.zipOrderCode,
      installationLocation: detail.installationLocation,
      description: detail.description,
      count: detail.count,
    } as FormalizedZipRequestDto;
  }, []);

  const handleEdit = useCallback(async (item: FormalizedZipListItem) => {
    setEditingId(item.id || null);
    setIsModalOpen(true);
    if (item.id) {
      const res = await loadDetail(item.id);
      if (res.success) {
        setEditingItem(mapDetailToForm(res.detail));
      }
    }
  }, [loadDetail, mapDetailToForm]);

  const handleDelete = useCallback(async (id: number) => {
    // eslint-disable-next-line no-alert
    if (window.confirm('Удалить запись?')) {
      await deleteById(id);
      await loadFormalizedZips();
    }
  }, [deleteById, loadFormalizedZips]);

  const handleSubmit = useCallback(async (data: FormalizedZipRequestDto) => {
    await updateExisting(editingId, data);
    setIsModalOpen(false);
    setEditingItem(null);
    setEditingId(null);
    await loadFormalizedZips();
  }, [editingId, updateExisting, loadFormalizedZips]);

  const handleCancel = useCallback(() => {
    setIsModalOpen(false);
    setEditingItem(null);
    setEditingId(null);
  }, []);

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 16 }}>
        <h1>Формализованные ЗИП</h1>
      </div>
      {formalizedZips.length === 0 ? (
        <div style={{ padding: 24 }}>
          <EmptyState message="Формализованные ЗИП не найдены" />
        </div>
      ) : (
        <FormalizedZipTable items={formalizedZips} onEdit={handleEdit} onDelete={handleDelete} />
      )}

      <FormalizedZipForm
        isOpen={isModalOpen}
        editingItem={editingItem}
        isEditing={!!editingId}
        onSubmit={handleSubmit}
        onCancel={handleCancel}
      />
    </div>
  );
};
